<script lang="ts">
import CompanyEditor from "@/Components/CompanyEditor.vue";
import MainPage from "@/Components/MainPage.vue";
import Authenticated from "@/Layouts/Authenticated.vue";
import { Company, EconomicSectors, Policies, QualificationsGroups } from "@/Types";
import axios from "axios";
import { defineComponent, PropType } from "vue";

export default defineComponent({
    name: "EditCompanyVue",
    components: { CompanyEditor, MainPage },
    layout: Authenticated,
    props: {
        qualificationGroups: {
            type: Object as PropType<QualificationsGroups>,
            required: true,
        },
        economicSectors: {
            type: Object as PropType<EconomicSectors>,
            required: true,
        },

        company: {
            type: Object as PropType<Company>,
            default: null,
        },
        policies: {
            type: Object as PropType<Policies>,
            default: null,
        },
        imageSize: {
            type: Number, // in MB
            required: true,
        },
    },
    methods: {
        submit(data: Company, clbk: (error?: unknown) => void, preserveState: boolean, copy: boolean): void {
            if (copy) {
                axios
                    .post(route("companies.store"), data)
                    .then(() => {
                        if (clbk) clbk();
                        if (!preserveState) this.$inertia.visit(route("companies.index"), { preserveState: false });
                    })
                    .catch((error) => {
                        if (clbk) clbk(error);
                    });
            } else {
                axios
                    .put(route("companies.update", this.company.id), data)
                    .then(() => {
                        if (clbk) clbk();
                        if (!preserveState) this.$inertia.visit(route("companies.index"), { preserveState: false });
                    })
                    .catch((error) => {
                        if (clbk) clbk(error);
                    });
            }
        },
    },
});
</script>

<template>
    <MainPage :title="$trans('acp.company_edit')" :gap="true">
        <CompanyEditor :economic-sectors="economicSectors" :policies="policies" :company="company" :qualification-groups="qualificationGroups" :image-size="imageSize" :emit-actions="true" @submit="submit" />
    </MainPage>
</template>
